export default __webpack_public_path__ + "static/media/hd.6c9677f8.svg";